import React, { FC } from "react";
import Modal from "Components/Modal/Modal";
import { useTranslation } from "Providers/TranslationProvider";
import { Button, DialogContent } from "@material-ui/core";
import ModalTitle from "Components/Modal/ModalTitle";
import { useAuthSignOutModal } from "./hooks/useAuthSignOutModal";
import { useAuthUser } from "./hooks/useAuthUser";
import { useSnackbar } from "material-ui-snackbar-provider";
import { verifyError } from "Components/Common/helpers/verifyError";

const AuthSignOutModal: FC = () => {
	const { t } = useTranslation();
	const isOpen = useAuthSignOutModal((state) => state.isOpen);
	const snackbar = useSnackbar();

	const signOut = async () => {
		try {
			await useAuthUser.getState().signOut();
			useAuthSignOutModal.getState().close();
		} catch (error) {
			snackbar.showMessage(verifyError(error).message);
		}
	};

	if (!isOpen) return null;

	return (
		<Modal modalController={useAuthSignOutModal.getState()}>
			<ModalTitle
				close={useAuthSignOutModal.getState().close}
				title={t("AuthSignOutModal_Title")}
			>
				<Button variant="contained" onClick={signOut} color="primary">
					{t("Common_Yes")}
				</Button>
			</ModalTitle>
			<DialogContent>{t("AuthSignOutModal_Description")}</DialogContent>
		</Modal>
	);
};

export default AuthSignOutModal;
